<template>
  <div class="section">
    <div class="container" id="countryDash">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h2 class="title is-1">Questionnaires</h2>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item" v-if="$store.getters.isAdmin">
            <button class="button is-link" @click="$router.push({name:'userAdmin'})">Manage Users</button>
          </div>
        </div>
      </div>
      <div v-if="questionnaires.length > 0">
        <br /><br />
        <div class="title is-3">
          Open questionnaires
        </div>
        <b-table :data="questionnaires"
                 :hoverable="true"
                 :loading="isLoadingOpen"
                 :mobile-cards="true"
                 :paginated="true"
                 :per-page="10"
                 :pagination-simple="true">
          <b-table-column field="Country" label="Country Questionnaires" v-slot="props">
            <a @click="goToQuestionnaire(props.row)">{{props.row.Country}}</a>
          </b-table-column>
          <b-table-column field="Period" label="Period" v-slot="props">
            {{ props.row.Period }}
          </b-table-column>
          <b-table-column field="LastUpdated" label="Last Updated" v-slot="props">
            {{ props.row.LastUpdated | utc | moment('M/DD/YYYY') }}
          </b-table-column>
          <b-table-column field="exporting" label="Export PDF" v-slot="props">
            <button class="button is-default" :class="{'is-loading': props.row.exporting }" @click="Export(props.row)">Download</button>
            <div v-if="props.row.exporting" :key="props.row.Id">
              <export @complete="SetExporting(props.row, false)" :options="props.row.exportOptions"></export>
            </div>
          </b-table-column>
        </b-table>
      </div>
      <div v-if="pastQuestionnaires.length > 0">
        <br /><br />
        <div class="title is-3">
          Previous Questionnaires
        </div>
        <b-table :data="pastQuestionnaires"
                 :hoverable="true"
                 :loading="isLoadingPast"
                 :mobile-cards="true"
                 :paginated="true"
                 :per-page="10"
                 :pagination-simple="true">
          <b-table-column field="Country" label="Country Questionnaires" v-slot="props">
            {{props.row.Country}}
          </b-table-column>
          <b-table-column field="Period" label="Period" v-slot="props">
            {{ props.row.Period }}
          </b-table-column>
          <b-table-column field="LastUpdated" label="Last Updated" v-slot="props">
            {{ props.row.LastUpdated | utc | moment('M/DD/YYYY') }}
          </b-table-column>
        </b-table>
      </div>
      <div v-if="changes.length > 0">
        <br /><br />
        <div class="title is-3">
          10 Most Recent Changes
        </div>
        <b-table :data="changes"
                 :hoverable="true"
                 :loading="isLoadingChange"
                 :mobile-cards="true">
          <b-table-column field="User" label="User" v-slot="props">
            {{ props.row.User }}
          </b-table-column>
          <b-table-column field="Questionnaire" label="Questionnaire" v-slot="props">
            {{ props.row.Questionnaire }}
          </b-table-column>
          <b-table-column width="500" field="Question" label="Question" v-slot="props">
            <a @click="showChanges(props.row)"><p v-html="props.row.Question"></p></a>
          </b-table-column>
          <b-table-column field="Stamp" label="Stamp" v-slot="props">
            {{ props.row.Stamp | utc | moment('M/DD/YYYY') }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
  import exportTool from '@/components/user/questionnaire/printQuestionnaire.vue';
  import showChanges from "@/components/modals/showChanges.vue";
  export default {
    components: {
      "export": exportTool
    },
    data: function () {
      return {
        questionnaires: [],
        changes: [],
        pastQuestionnaires: [],
        isLoadingOpen: false,
        isLoadingPast: false,
        isLoadingChange: false
      }
    },
    methods: {
      Export(row) {
        //console.log(row);
        row.exportOptions = { PeriodName: row.Period, CountryName: row.Country, Status: row.Status, ClosedOn: row.ClosedOn, GroupId: row.GroupId, Id: row.QuestionnaireId };
        this.SetExporting(row, true);
      },
      SetExporting(row, bool) {
        row.exporting = bool;
        this.questionnaires = this.questionnaires.slice(0);
      },
      async showChanges(change) {
        await this.$http.post("api/questionnaire/changes/question", { questionId: change.QuestionId, questionnaireId: change.QuestionnaireId, groupId: change.GroupId })
          .then(resp => {
            this.$buefy.modal.open({
              parent: this,
              component: showChanges,
              hasModalCard: true,
              props: {
                changes: resp.data,
              },
            })
          }).catch(err => {
            console.error(err);
          })
      },
      goToQuestionnaire(questionnaire) {
        this.$store.dispatch("setQuestionnaire", { GroupId: questionnaire.GroupId, Id: questionnaire.QuestionnaireId, CountryName: questionnaire.Country, Status: questionnaire.Status, ClosedOn: questionnaire.ClosedOn });
        this.$router.push('/questionnaire/participation');
      },
      RefreshQuestionnaires() {
        this.isLoadingOpen = true;
        this.$http.get("api/questionnaire/open")
          .then(resp => {
            this.questionnaires = resp.data;
            this.isLoadingOpen = false;
          }).catch(err => {
            this.isLoadingOpen = false;
            console.error(err);
          });

        this.isLoadingPast = true;
        this.$http.get("api/questionnaire/completed")
          .then(resp => {
            this.pastQuestionnaires = resp.data;
            this.isLoadingPast = false;
          }).catch(err => {
            this.isLoadingPast = false;
            console.error(err);
          });
      },
      RefreshChangelog(numRecords) {
        this.isLoadingChange = true;
        this.$http.get("api/questionnaire/changes/" + numRecords)
          .then(resp => {
            this.changes = resp.data;
            this.isLoadingChange = false;
          }).catch(err => {
            this.isLoadingChange = false;
          });
      }
    },
    created() {
      this.RefreshQuestionnaires();
      this.RefreshChangelog(10);
    }
  }
</script>

<style>
</style>
